// import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../../../Components/Buttons/ButtonComponent";
import bg_map from "./bg_map.png";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const blog_image = `${digitalOceanURL}/SingleBlogImg/blog_img_bg.png`;
const blog_small_image = `${digitalOceanURL}/SingleBlogImg/blog_small_img.png`;

const SingleBlogHeroSection = () => {
  return (
    <div className="relative blog_bg_img background_color">
      {/* ---------------------------show this for lg and md device------------------------------------- */}
      <div className="lg:relative lg:top-12 flex flex-col lg:mx-12 box_blog_space">
        <div className="flex flex-col lg:relative lg:right-10 leading-tight z-[2] blog-box mt-4">
          <div className="p-2 mt-4 lg:ml-16">
            <div className="text-wrap mt-14 lg:mt-20 md:mt-20 bold-text font-[poppins] text-center">
              <h1 className="text-[32px] md:text-[46px] lg:text-[46px]">
                All-in-One Onboarding and Verification
              </h1>
            </div>
            <div className="text-wrap px-2 lg:px-0 md:px-0 font-[poppins] text-[16px] mt-4 md:mt-6 lg:mt-6 text-center">
              <p>
                Streamline hiring with secure, blockchain-based background
                checks
                <br className="hidden md:block lg:block" />
                Trust Hirestar.io for verified and transparent employee
                screening
              </p>
            </div>
          </div>

          {/* --------------------------buttons-------------------- */}
          <div className="flex justify-center mt-4">
            <ButtonComponent
              arialLabel={"All-in-One Onboarding and Verification"}
            />
          </div>
        </div>

        <div className="large-image relative mt-0 lg:-top-12">
          {/* Home Image */}
          <img
            className="home-image w-full object-cover "
            alt="hero img for single blog page"
            title="hero img  blog page"
            src={blog_image}
            loading="lazy"
          />
        </div>

        {/* -------------------------show this for small device-------------------------------------- */}
     <div className="relative w-full max-w-sm mx-auto small-image lg:hidden">
  <div className="overflow-hidden rounded-lg w-full h-92"> {/* Set a height here */}
    <div className="w-full h-full"> {/* Full size wrapper */}
      <img
        src={blog_small_image}
        alt="small img for single blog page"
        title="small img blog page"
        className="w-full h-full object-cover"
      />
    </div>
  </div>
</div>

      </div>
    </div>
    
  );
};

export default SingleBlogHeroSection;
